import React, { useState, useEffect } from 'react'
import { Link, useNavigate  } from "react-router-dom"
import './login.css'
import API_URL from '../common/Apiurl';

function Login(){
    const apiUrl = API_URL;
    const navigate  = useNavigate();
    useEffect(() => {
        if(localStorage.getItem('user-info')){
            navigate('/admin/dashboard')
        }
    },[navigate])
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState(""); 
    const [enteredEmailIsvalid, setenteredEmailIsvalid] = useState(true);
    const [enteredPasswordIsvalid, setenteredPasswordIsvalid] = useState(true);
    const [enteredCredIsvalid, setenteredCredIsvalid] = useState(true);

    async function clicktocheck(){
        if(email.trim() === ''){
            setenteredEmailIsvalid(false);
            return; 
        }
        if(password.trim() === ''){
            setenteredPasswordIsvalid(false);
            return;
        }
        setenteredEmailIsvalid(true);
        setenteredPasswordIsvalid(true);
        
        const postData = {
            email: email,
            password: password,
        };
        const result = await fetch(`${apiUrl}/adminlogin`,{
            method:'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData)
        });
        const data = await result.json();
        if((data.status === 200) && (data.message === "Login Successfull")){
            const userToken = data.data.token;
            localStorage.setItem("user-info",JSON.stringify(data))
            localStorage.setItem("user-token",userToken)
            // localStorage.setItem("user-token",JSON.stringify(userToken))
            navigate('/admin/dashboard')
            // console.log(data.message);
        }
        else{
            setenteredCredIsvalid(false);
            navigate('/')
        }
    }
    return <div className='loginbg'>
            <div className="container">
                <div className="form-box">
                    <div className="input-group mb-1 mt-1">
                        {!enteredCredIsvalid && <span className='error-text position-relative zIndex'>Entered Crendentials is invalid.</span>}
                    </div>
                    <div className="body-form">
                        <form>
                            <div className="input-group mb-4 position-relative">
                                <span className="input-group-text"></span>
                                <input type="email" onChange={(e)=>setEmail(e.target.value)} className="form-control" placeholder="Email" />
                                {!enteredEmailIsvalid && <span className='error-text'>Please Enter an Email.</span>}
                            </div>
                            <div className="input-group mb-1 mt-1 position-relative">
                                <span className="input-group-text"></span>
                                <input type="password" onChange={(e)=>setPassword(e.target.value)} className="form-control" placeholder="Password" />
                                {!enteredPasswordIsvalid && <span className='error-text'>Please Enter password.</span>}
                            </div>
                            <button onClick = {clicktocheck} type="button" className="btn btn-secondary btn-block mt-3">LOGIN</button>
                            <div className="message">
                                <div>
                                    <Link to="/enteremail">Forgot your password?</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    }

export default Login;


